import type { ChainModifiers, Entry, EntrySkeletonType, LocaleCode, UnresolvedLink } from 'contentful';

export function isResolvedLinkEntry<
    EntrySkeleton extends EntrySkeletonType,
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode,
>(
    entry?: UnresolvedLink<'Entry'> | Entry<EntrySkeleton, Modifiers, Locales> | null
): entry is Entry<EntrySkeleton, Modifiers, Locales> {
    return typeof entry === 'object' && entry !== null && 'fields' in entry;
}
